










import { Guid } from 'guid-typescript'
import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

import { CustomConnection } from '../../../logic/Connections/CustomConnection'
import CustomEditor from '../../../logic/Editor/CustomEditor'
import { CtxMenuItem } from '../logic/MenuItems'
import ContextMenuItem from './Menu/ContextMenuItem.vue'

@Component({
  components: {
    ContextMenuItem
  }
})
export default class ConnectionSelectedMenu extends Vue {
  @VModel() isVisible!: boolean

  @Prop() connection!: CustomConnection

  @Prop() editor!: CustomEditor

  get contextMenuItems(): Array<CtxMenuItem> {
    return [
      {
        key: Guid.create().toString(),
        title: 'flow_context_menu_remove_connection',
        value: this.removeConnection,
        icon: {
          type: 'delete',
          class: 'text-danger'
        },
      },
      {
        key: Guid.create().toString(),
        title: this.toggleConnectionVisibilityTitle,
        icon: {
          type: this.visibleIcon,
        },
        value: this.toggleConnectionVisibility
      },
      {
        key: Guid.create().toString(),
        title: this.toggleConnectionHighlightTitle,
        icon: {
          type: this.toggleConnectionHighlightIcon,
        },
        value: this.toggleHighlight
      },
    ]
  }

  get toggleConnectionHighlightIcon() {
    if (this.editor.isConnectionHighlighted(this.connection)) {
      return 'bedtime_off'
    } else {
      return 'highlight'
    }
  }

  get toggleConnectionHighlightTitle() {
    if (this.editor.isConnectionHighlighted(this.connection)) {
      return 'flow_context_menu_disable_highlight'
    }

    return 'flow_context_menu_enable_highlight'
  }

  get toggleConnectionVisibilityTitle() {
    if (this.connection.data.visible) {
      return 'flow_context_menu_hide_connection'
    } else {
      return 'fake_socket_show_connection_button'
    }
  }

  get visibleIcon() {
    if (this.connection.data.visible) {
      return 'visibility_off'
    } else {
      return 'visibility'
    }
  }

  toggleHighlight() {
    this.editor.toggleConnectionHighlight(this.connection)

    this.isVisible = false
  }

  removeConnection(): void {
    this.editor.removeConnection(this.connection)
    this.isVisible = false
  }

  toggleConnectionVisibility(): void {
    this.editor.toggleConnectionVisibilityHandler(this.connection)
    this.isVisible = false
  }
}
